import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";

import BarCodeScanner from "../BarCodeScanner.jsx";
import DropDown from "../../../common/components/DropDown.jsx";
import FilterComponent from "./FilterComponent.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import QueryResaultList from "./QueryResaultList.jsx";
import React from "react";
import Scroll from "../../../common/components/Scroll.jsx";
import TextField from "../../../common/components/TextField.jsx";
import { hasCamera } from "../../util/camera.js";
import { makePropertyValue } from "../../../common/util/changeUtils.jsx";

class SearchBar extends React.Component {
    constructor(props){
        super(props);
        
        this.state = {
            filterActive: false,
            expanded: false,
            searchString: "",
            hasCamera: false,
            scanning: false
        };
        this.wrapperRef = React.createRef();

        this.hideFilter = this.hideFilter.bind(this);
        this.onClickFilter = this.onClickFilter.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onClickSeeAll = this.onClickSeeAll.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.trackScrolling = this.trackScrolling.bind(this);

        this.onClickScan = this.onClickScan.bind(this);
        this.onBarcodeFound = this.onBarcodeFound.bind(this);
        this.onBarcodeCancel = this.onBarcodeCancel.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        const {
            onEdit,
            filter,
            initialFilter,
        } = this.props;

        const searchString = initialFilter ? initialFilter : "";

        onEdit({
            ReturnTobacco: false,
            OnlyCampaigns: false,
            OnlyNews: false,
            OnlyLastSold: false,
            ProductGroupId: null,
            SupplierId: null,
            SortingColumn: null,
            ...filter,
            searchString: searchString,
        });

        this.setState({
            searchString:  searchString,
        });
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        hasCamera().then(exists => this.setState({
            hasCamera: exists
        }));
    }

    componentWillUnmount() {
        if( this.props.clearQuery ){
            this.props.clearQuery();
        }
    }

    trackScrolling() {
        const {
            loadMoreProducts,
            isLoading,
        } = this.props;

        //load more products if none is loading
        if( isLoading===false && loadMoreProducts){
            loadMoreProducts(50);
        }
    }

    hideFilter() {
        this.setState({filterActive:false});
    }
    onClickFilter() {
        const {
            disabled,
            localization,
            setDropDown,
        } = this.props;

        if( !disabled ){
            this.props.setDropDown(
                <DropDown rect={this.wrapperRef.current.getBoundingClientRect()} style={{width:304, overflow:"visible"}} shiftLeft={true} below={true} setDropDown={setDropDown} onComponentWillUnmount={this.hideFilter}>
                    <FilterComponent localization={localization} onEdit={this.onEdit} setDropDown={setDropDown}/>
                </DropDown>
            );
            this.setState({
                filterActive: true,
            });
        }
    }
    onClickScan(event) {
        if (this.state.hasCamera) {
            this.setState({
                scanning: true
            });
        }
        event.preventDefault();
        event.stopPropagation();
    }
    handleClickOutside() {
        // Clear search
        this.setState({
            expanded: false,
            searchString: "",
        });
    }
    onClickSeeAll(event) {
        this.props.onClickShowProducts(event, "all");
    }
    onEdit(change) {
        const {
            onEdit,
            showResaults,
        } = this.props;
        
        onEdit({
            ...change,
        });
        
        if( change.searchString && this.state.expanded !== (change.searchString.length>0 && showResaults) && change.searchString!==this.state.searchString ){
            this.setState({
                expanded: change.searchString?change.searchString.length>0 && showResaults : this.state.expanded,
                ...change,
            });
        } else {
            this.setState({
                ...change,
            });
        }
    }

    onBarcodeFound(result) {
        this.setState({
            scanning: false
        });
        this.onEdit(makePropertyValue("searchString", result), this.state);
    }

    onBarcodeCancel() {
        this.setState({
            scanning: false
        });
    }

    render(){
        const {
            disabled,
            deviceType,
            localization,
            useFilter,
            usingSubmit,
            style,
            productQuery,
            activeOrder,
            addRemoveProductToTemporaryOrder,
            setModal,
        } = this.props;

        const tinyDevice = deviceType=="sm" || deviceType=="xs";

        const showSearchResaults = !disabled && this.state.expanded && this.props.showResaults && productQuery.filter.searchString && productQuery.filter.searchString.length>0;

        const isFilterSelected = this.state.ProductGroupId!=null || this.state.SupplierId!=null;
        const isFilterActive = this.state.filterActive || isFilterSelected;

        return (
            <React.Fragment>
                {showSearchResaults && (
                    <div className="dim-screen" onClick={this.handleClickOutside} style={{zIndex:showSearchResaults?"1":undefined}}/>
                )}
                <div className={"card-default search-bar"} style={{zIndex:showSearchResaults?"2":undefined,opacity:disabled?0.5:1.0,...style}}>
                    <div className="search-wrapper" style={{flexFlow:useFilter?"row":"column"}} onClick={this.onClickFilter}>
                        <TextField className="search-container" disabled={disabled} placeholder={localization.text("order","searchForProducts")} iconType={iconTypes.search} isValid={true} source={this.state} property="searchString" onEdit={this.onEdit} usingSubmit={usingSubmit}/>
                        {showSearchResaults && (
                            <div className="search-resaults-dropdown" style={{height:"500px"}}>
                                <Scroll style={{height:"400px",overflowX:"auto", width:"100%"}} onCloseToBottom={this.trackScrolling}>
                                    <QueryResaultList localization={localization} productQuery={productQuery} activeOrder={activeOrder} addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder} setModal={setModal}/>
                                </Scroll>
                                <div className="bottom-panel">
                                    <button className="btn icon" onClick={this.handleClickOutside}>
                                        <Icon type={iconTypes.x} color={iconColor.red}/>
                                        {localization.text("order","close")}
                                    </button>
                                    <button className="btn icon primary" onClick={this.onClickSeeAll}>
                                        <Icon type={iconTypes.x} color={iconColor.red}/>
                                        {localization.text("order","seeAllCountResaults",{count:productQuery.resaultCountString})}
                                    </button>
                                </div>
                            </div>
                        )}
                        {this.state.hasCamera && useFilter && (
                            <div className="search-button-scan" onClick={this.onClickScan}>
                                <Icon className="search-button-scan-icon noselect" type={iconTypes.scan}/>
                            </div>
                        )}
                        {useFilter && (
                            <div className={`search-button-filter ${isFilterActive?"active":""} ${tinyDevice?"tinyDevice":"largeDevice"}`} ref={this.wrapperRef}>
                                <Icon type={iconTypes.filter} className={"search-button-filter-icon noselect"} color={isFilterActive?iconColor.white:iconColor.dark} />
                                {!tinyDevice && (
                                    <div className={`search-button-filter-text noselect ${isFilterActive?"active":""}`}>
                                        {localization.text("order","filterResaults")}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {this.state.hasCamera && !useFilter && (
                        <div className="search-button-scan-no-filter" onClick={this.onClickScan}>
                            <Icon className="search-button-scan-icon noselect" type={iconTypes.scan}/>
                        </div>
                    )}
                </div>
                {this.state.scanning && <BarCodeScanner onBarcodeFound={this.onBarcodeFound} onCancel={this.onBarcodeCancel}/>}
            </React.Fragment>
        );
    }
}

SearchBar.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    onEdit: PropTypes.func.isRequired,
    clearQuery: PropTypes.func,
    onClickShowProducts: PropTypes.func,
    useFilter: PropTypes.bool,
    filter: PropTypes.object.isRequired,
    setModal: PropTypes.func,
    setDropDown: PropTypes.func,
    style: PropTypes.object,
    // If we should display the resaults in a dropdown
    showResaults: PropTypes.bool,
    // if using form and callbacks for onEdit is not wanted
    usingSubmit: PropTypes.bool,
    disabled: PropTypes.bool,
    productQuery: PropTypes.object,
    activeOrder: PropTypes.object,
    addRemoveProductToTemporaryOrder: PropTypes.func,
    loadMoreProducts: PropTypes.func,
    isLoading: PropTypes.bool,
    initialFilter: PropTypes.string,
};
SearchBar.defaultProps = {
    disabled: false,
};

export default SearchBar;